import { render, staticRenderFns } from "./App.vue?vue&type=template&id=635d9b1e&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=635d9b1e&prod&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=635d9b1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports